export interface CompanyProfile {
  symbol: string;
  price: number;
  beta: number;
  volAvg: number;
  mktCap: number;
  lastDiv: number;
  range: string;
  changes: number;
  companyName: string;
  currency: string;
  isEtf: boolean;
  isin: string;
  cusip: string;
  exchange: string;
  exchangeShortName: string;
  industry: string;
  website: string;
  description: string;
  ceo: string;
  sector: string;
  country: string;
  fullTimeEmployees: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  dcfDiff: number;
  dcf: number;
  image: string;
  ipoDate: string;
}

export const emptyProfile = {
  symbol: '',
  price: 0,
  beta: 0,
  volAvg: 0,
  mktCap: 0,
  lastDiv: 0,
  range: '',
  changes: 0,
  companyName: '',
  currency: '',
  isEtf: false,
  isin: '',
  cusip: '',
  exchange: '',
  exchangeShortName: '',
  industry: '',
  website: '',
  description: '',
  ceo: '',
  sector: '',
  country: '',
  fullTimeEmployees: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  dcfDiff: 0,
  dcf: 0,
  image: '',
  ipoDate: '',
};

export interface CompanyQuote {
  symbol: string;
  name: string;
  price: number;
  changesPercentage: number;
  change: number;
  dayLow: number;
  dayHigh: number;
  yearHigh: number;
  yearLow: number;
  marketCap: number;
  priceAvg50: number;
  priceAvg200: number;
  volume: number;
  avgVolume: number;
  exchange: string;
  open: number;
  previousClose: number;
  eps: number;
  pe: number;
  earningsAnnouncement: string;
  sharesOutstanding: number;
  timestamp: number;
}

export const emptyQuote = {
  symbol: '',
  name: '',
  price: 0,
  changesPercentage: 0,
  change: 0,
  dayLow: 0,
  dayHigh: 0,
  yearHigh: 0,
  yearLow: 0,
  marketCap: 0,
  priceAvg50: 0,
  priceAvg200: 0,
  volume: 0,
  avgVolume: 0,
  exchange: '',
  open: 0,
  previousClose: 0,
  eps: 0,
  pe: 0,
  earningsAnnouncement: '',
  sharesOutstanding: 0,
  timestamp: 0,
};

export interface StockNews {
  symbol: string;
  publishedDate: string;
  title: string;
  image: string;
  site: string;
  text: string;
  url: string;
}

export interface TreasuryRates {
  date: string;
  month1: number;
  month2: number;
  month3: number;
  month6: number;
  year1: number;
  year2: number;
  year3: number;
  year5: number;
  year7: number;
  year10: number;
  year20: number;
  year30: number;
}

export interface PriceTargetConsensus {
  symbol: string;
  targetHigh: number;
  targetLow: number;
  targetConsensus: number;
  targetMedian: number;
}

export interface UpdownGradeConsensus {
  symbol: string;
  strongBuy: number;
  buy: number;
  hold: number;
  sell: number;
  strongSell: number;
  consensus: string;
}

export const PRICE_TARGET_API = (ticker: string) => `/v1/stock/pricetarget?ticker=${ticker}`;
export const UPGRADE_DOWNGRADE_CONSENSUS_API = (ticker: string) =>
  `/v1/stock/upgrades-downgrades-consensus?ticker=${ticker}`;
export const CALENDAR_DATA_BY_DATE = '/v1/products/calendars';
